import React from 'react';
import css from './insights.less';
// @ts-expect-error ts-migrate(7016) FIXME: Try `npm install @types/chart.js` if it exists or ... Remove this comment to see the full error message
import Chart from 'chart.js';
import kb from '../../kb';

type Props = {
    width?: number;
    height?: number;
    labelKey?: string;
    datasets?: any[];
    colorKey?: string;
    data?: any[];
};


export default class LineChart extends React.PureComponent<Props> {
    static defaultProps = {
        width: 400,
        height: 400,
        colorKey: 'color',
        labelKey: 'label',
    }

    canvas: any;
    chart: any;

    componentDidMount() {
        const ctx = this.canvas.getContext('2d');
        this.chart = new Chart(ctx, {
            type: 'line',
            options: {
                legend: {
                    display: true,
                },
                tooltips: {
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        label: function (tooltipItem: any, data: any) {
                            const dataset = data.datasets[tooltipItem.datasetIndex];
                            const index = tooltipItem.index;
                            return `${dataset.label}: ${kb.formatCurrency(dataset.data[index])}`;
                        }
                    }
                },
                hover: {
                    mode: 'index',
                    intersect: false
                },
                // scales: {
                //     xAxes: [{
                //         display: true,
                //         scaleLabel: {
                //             display: true,
                //             labelString: 'Month'
                //         }
                //     }],
                //     yAxes: [{
                //         display: true,
                //         scaleLabel: {
                //             display: true,
                //             labelString: 'Value'
                //         }
                //     }]
                // }
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                callback: function (label: any, index: any, labels: any) {
                                    return kb.numberFormat(label);
                                }
                            },
                            // scaleLabel: {
                            //     display: true,
                            //     labelString: '1k = 1000'
                            // }
                        }
                    ]
                },
            },

            data: {
                // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                datasets: this.props.datasets.map((ds: any) => ({
                    label: ds.label,

                    // point fill color
                    backgroundColor: ds.color,

                    borderColor: ds.color,
                    pointHoverRadius: 5,
                    pointRadius: 4,
                    pointBorderColor: '#fff',
                    pointBorderWidth: '1px',
                    pointHoverBorderColor: '#fff',
                    pointHoverBorderWidth: '2px',

                    // pointHoverBackgroundColor: 'red',
                    // pointStrokeColor: "#fff",
                    data: [],

                    fill: false
                })),
            }
        });
        this.refresh();
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (prevProps.data !== this.props.data) {
            this.refresh();
        }
    }

    refresh = () => {

        if (this.props.data) {
            // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
            this.chart.data.labels = this.props.data.map((row: any) => row[this.props.labelKey]);

            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            this.props.datasets.forEach((ds: any, i: any) => {
                // console.log(this.chart.data.datasets);
                // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                this.chart.data.datasets[i].data = this.props.data.map((row: any) => row[ds.key]);
            })
            // this.chart.data.datasets = this.props.datasets.map(ds => ({
            //     label: ds.label,
            //     backgroundColor: ds.color, // point fill color
            //     borderColor: ds.color,
            //     pointHoverRadius: 5,
            //     pointRadius: 4,
            //     pointBorderColor: '#fff',
            //     pointBorderWidth: '1px',
            //     pointHoverBorderColor: '#fff',
            //     pointHoverBorderWidth: '2px',
            //     // pointHoverBackgroundColor: 'red',
            //     // pointStrokeColor: "#fff",
            //     data: this.props.data.map(row => row[ds.key]),
            //     fill: false,
            // }))
            // console.log(this.chart.data.datasets);
            this.chart.update();
        }

    };

    setCanvas = (n: any) => {
        this.canvas = n;
    };

    render() {
        const {width, height} = this.props;

        return (
            <div className={css.chartContainerWrap}>
                <div className={css.chartContainer}>
                    <canvas ref={this.setCanvas} width={width} height={height}/>
                </div>
            </div>
        )
    }
}
